import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPQantWeb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6097_792)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.45007 18C6.03586 18 5.70007 17.6642 5.70007 17.25L5.70007 13.5C5.70007 13.0858 6.03586 12.75 6.45007 12.75H8.70007C9.11429 12.75 9.45007 13.0858 9.45007 13.5L9.45007 17.25C9.45007 17.6642 9.11429 18 8.70007 18H6.45007Z",
				fill: "#32C8DC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.45007 3C6.03586 3 5.70007 2.66421 5.70007 2.25L5.70007 0.75C5.70007 0.335786 6.03586 1.16457e-07 6.45007 9.83509e-08L8.70007 0C9.11429 -1.81059e-08 9.45007 0.335787 9.45007 0.75L9.45007 2.25C9.45007 2.66421 9.11429 3 8.70007 3H6.45007Z",
				fill: "#32C8DC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 4.79941C0 4.30236 0.402944 3.89941 0.9 3.89941H13.7222C13.9638 3.89941 14.1954 3.99661 14.3646 4.16913L17.3814 7.24413C17.7248 7.59416 17.7248 8.15467 17.3814 8.5047L14.3646 11.5797C14.1954 11.7522 13.9638 11.8494 13.7222 11.8494H0.900002C0.402945 11.8494 0 11.4465 0 10.9494V4.79941Z",
				fill: "#005AFF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6097_792",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgPQantWeb;
